import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.highlightElement(this.element);
  }
  
  highlightElement(element, delay = 0, duration = 2000) {

      console.log('DEBUG highlightElement');

    setTimeout(() => {
      element.classList.add('seabird-color-highlight2', 'seabird-tone-down-4', 'seabird-lighten-2a');
      setTimeout(() => {
        element.classList.remove('seabird-color-highlight2', 'seabird-tone-down-4', 'seabird-lighten-2a');
      }, duration);
    }, delay * 0.8 * duration);
  }

}